import { Component, Input } from '@angular/core';
import { MaquinasService, MenuService, AlertService } from '@app/_services';

import { Router } from "@angular/router";

import { TranslateService } from '@ngx-translate/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-maquina-secciones-ejes',
  templateUrl: './maquinaDetalleEjes.component.html'
})

export class MaquinaDetalleSeccionesEjesComponent {

  @Input() id: string;

  public ejes: [];
  public ejes_seleccionados: number[] = [];
  public ejes_modalReference: NgbModalRef;
  public ejes_modalReferenceLoading: NgbModalRef;

  constructor(
    private maquinasService: MaquinasService,
    public router: Router,
    private menuService: MenuService,
    private translateService: TranslateService,
    private alertService: AlertService) {

    this.menuService.titulo = this.translateService.instant('maquina').toUpperCase();
  }

  ngOnInit() {

    this.maquinasService.GetAll_Ejes(this.id).subscribe((result) => {
      this.ejes = result.data;
    });

  }

  ejes_onClickNuevo() {
    if (this.id != undefined) {
      this.router.navigate(['maquinas/eje/crear/' + this.id]);
    } else {
      this.alertService.warn(this.translateService.instant('creaPrimeroLaMaquina'), { keepAfterRouteChange: true });
    }
  }

  ejes_onClickEditar() {
    if (this.ejes_seleccionados[0] > 0) {
      if (this.id != undefined) {
        this.router.navigate(['maquinas/eje/editar/' + this.id + "/" + this.ejes_seleccionados[0]]);
      }
    }
  }

  ejes_cellClick(e) {
    if (e.columnIndex > 0) {
      if (this.id != undefined) {
        this.router.navigate(['maquinas/eje/editar/' + this.id + "/" + this.ejes_seleccionados[0]]);
      }
    }
  }

}
